import { apiClient } from "@/lib/apiClient";
import type {
  MfaEnrollResponse,
  MfaVerifyEnrollmentRequest,
  MfaVerifyEnrollmentResponse,
  MfaVerifyRequest,
} from "@/types/mfa";

export const getMfaEnrollData = async (): Promise<MfaEnrollResponse> => {
  const res = await apiClient.get<MfaEnrollResponse>("/auth/mfa/enroll");
  return res.data;
};

export const verifyMfaEnrollment = async (
  payload: MfaVerifyEnrollmentRequest
): Promise<MfaVerifyEnrollmentResponse> => {
  const res = await apiClient.post<MfaVerifyEnrollmentResponse>(
    "/auth/mfa/verify-enrollment",
    payload
  );
  return res.data;
};

export const verifyMfa = async (payload: MfaVerifyRequest): Promise<void> => {
  await apiClient.post("/auth/mfa/verify", payload);
};
